import { RefObject, createContext } from 'react';

import { PropertyGridCellKey } from './types.ts';

export type PropertyGridFocusContextValue = {
  activeTargetKey: PropertyGridCellKey | undefined;
  registerField: (key: PropertyGridCellKey, ref: RefObject<HTMLElement>) => void;
  unregisterField: (key: PropertyGridCellKey) => void;
};

export const PropertyGridFocusContext = createContext<PropertyGridFocusContextValue>({
  activeTargetKey: undefined,
  registerField: () => {},
  unregisterField: () => {},
});
